import { Component, OnInit } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Location } from '@angular/common';
import { UserPermission } from 'src/app/enums/enums';
import { PermissionService } from 'src/app/services/app/permission-access-service/permissionBased.service';
import { CredentialService } from 'src/app/services/core/credential/credential.service';
import { NUMBER_OF_RECORDS } from 'src/app/utils/common.utils';
import { Subject, debounceTime, filter } from 'rxjs';
import { sweetAlert } from 'src/app/utils/swal';
@UntilDestroy()

@Component({
  selector: 'app-credential-list',
  templateUrl: './credential-list.component.html',
  styleUrls: ['./credential-list.component.css']
})
export class CredentialListComponent implements OnInit {
  companies:any = [];
  search: any = '';
  private searchSubject = new Subject<string>();
  currentPage: number = 1;
  totalPages = 0;
  totalResults = 0;
  numberOfRecords = NUMBER_OF_RECORDS;
  status:boolean = true;
  userPermission = UserPermission;
  selectedState:any;
  logObj:any;
  companyModalObj:any;
  constructor(
    private location: Location,
    private credentialService : CredentialService,
    public permissionService: PermissionService){}

  ngOnInit(): void {
  const state = this.location.getState();
  if (state && typeof state === 'object' && 'selectedItem' in state) {
    this.selectedState = (state as { selectedItem:any }).selectedItem;
    this.status = this.selectedState;
    this.location.replaceState(this.location.path());
  } else {
    this.status = true;
  }
    this.getCredentialCompanies(this.currentPage);
    this.initializeSearch();
  }

  getCredentialCompanies(page:number){
    const queryparams:any = {
      limit: this.numberOfRecords,
      page,
      sortBy:'createdAt:desc',
      isActive : this.status
    }


    if (this.search) {
      const trimmedSearch = this.search.trim();
      queryparams.search = trimmedSearch;
    }
    this.credentialService.getCompanies(queryparams)
      .pipe(untilDestroyed(this)).subscribe((data: any) => {
        if (data && data.results ) {
          this.companies = data.results
          this.totalPages = data.totalPages;
          this.totalResults = data.totalResults;
        }
      })
  }

  onPageChange(page: number) {
    this.currentPage = page;
    this.getCredentialCompanies(page);
  }

  onSelectStatus(): void {
    this.getCredentialCompanies(this.currentPage = 1);
  }

  canViewDetails() {
    return (
      this.permissionService.hasAnyPermission([
      this.userPermission.GET_THRESHOLD_DASHBOARD,
      this.userPermission.MANAGE_COMPANY,
      this.userPermission.GET_DRIVER,
      this.userPermission.GET_VEHICLE,
      this.userPermission.GET_FARES,
      this.userPermission.GET_THRESHOLD]) 
      || 
      this.permissionService.hasPermission([
      this.userPermission.GET_COMPANY_CONFIGURATION,
      this.userPermission.MANAGE_COMPANY_CONFIGURATION])
    );
  }

  canViewActions() {
    return (
      this.permissionService.hasAnyPermission([
      this.userPermission.GET_THRESHOLD_DASHBOARD,
      this.userPermission.MANAGE_COMPANY,
      this.userPermission.GET_DRIVER,
      this.userPermission.GET_VEHICLE,
      this.userPermission.GET_FARES,
      this.userPermission.GET_THRESHOLD]) 
      || 
      this.permissionService.hasPermission([
      this.userPermission.GET_COMPANY_CONFIGURATION,
      this.userPermission.MANAGE_COMPANY_CONFIGURATION])
      ||
      this.permissionService.hasPermission([
      this.userPermission.MANAGE_CHANGE_REASON])
    );
  }


     initializeSearch() {
      this.searchSubject
        .pipe(
          debounceTime(500), // wait for typing to stop
          filter((search:any) => !search || search.length >= 3)  // only trigger if >=3 chars OR empty (to reset search)
        ).subscribe(() => {
          this.currentPage = 1;
          this.getCredentialCompanies(this.currentPage);
        });
      }
    
      onSearchInput() {
        this.searchSubject.next(this.search);
      }


  openCompanyEditModal(company: any) {
    this.companyModalObj = company;
  }

  onSaveCompany(evt: any) {
    if (evt) {
      const idx = this.companies.findIndex((fs: any) => fs.id === evt.id);
      if (this.status === evt.isActive) {
        this.companies[idx] = evt;
      } else {
        this.companies.splice(idx, 1);
      }
    }
    this.companyModalObj = null;
  }

  async onSyncCompany(companyId: any) {
    this.credentialService.syncCompanyById(companyId).subscribe({
      next: (data: any) => {
        if (!data?.success) {
          sweetAlert('Error', data?.error || 'Company sync failed', 'error', 'Ok');
        }
        else {
          this.getCredentialCompanies(this.currentPage)
        }
      },
      error: (err: any) => {
        sweetAlert('Error', err, 'error', 'Ok');

      },
      complete: () => {
      }
    }
    )
  }

  onCloseCompanyModal() {
    this.companyModalObj = null;
  }

  openLogModal(driver:any){
    this.logObj = driver.id;
  }
}
